import(/* webpackMode: "eager" */ "/app/src/app/(layout)/(PALayout)/home/page.tsx");
